import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 bg-background-50">
      <div className="text-center">
        <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-background-200 text-foreground-400 mb-6">
          <i className="ri-emotion-sad-line text-3xl"></i>
        </div>
        <h1 className="text-5xl md:text-6xl font-heading font-bold text-foreground-900 mb-3">404</h1>
        <p className="text-foreground-600 mb-8 text-sm md:text-base">页面不存在或已被移除</p>
        <Link
          to="/"
          className="inline-flex items-center px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-left-line mr-2"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}